import React from 'react';
import s from './s.module.less';
import FrequencyQuestionSecion from 'components/FrequencyQuestionSecion';

//https://www.notion.so/klarityhealth/Text-Visit-Provider-FAQs-25918650acdf80ba81e0d28913956c36?source=copy_link

const FAQData1 = [
    {
        id: 1,
        pageId: 1,
        seq: 1,
        question: '1. Who can provide Text Visits?',
        answer: `
        Any licensed clinician in good standing who meets Klarity’s credentialing requirements. Clinicians need to indicate their interest via the Provider Portal, and Klarity Ops will approve. Criteria:
        <ul>
            <li>Clinicians who is approved to be listed on Klarity once (you can be paused listed status on helloklarity.com currently. For example, you are currently not accepting video visits but can perform duties in a text visit format)</li>
            <li>Overall good patient reviews and reputation </li>
            <li>No violation to Klarity platform rules</li>
        </ul>
        `,
    },
    {
        id: 2,
        pageId: 2,
        seq: 2,
        question: '2. Do I need to be licensed in the patient’s state?',
        answer: `
        Yes. You can only treat patients located in states where you hold an active license. Please only accept cases where you have an active license in. You could filter patient location in the Provider Portal. 
        `,
    },
    {
        id: 3,
        pageId: 3,
        seq: 3,
        question: '3. How do I access the case pool?',
        answer: `
        Through the Klarity Provider Portal. Once approved to accept text visits, you can browse available cases and select those that match your expertise.
        `,
    },
    {
        id: 4,
        pageId: 4,
        seq: 4,
        question: '4. Do I receive training before starting?',
        answer: `
       Yes, providers receive training documentations in the Klarity portal. You’ll have access to Text Visit Code of Conduct, visit notes, e-prescribing, and patient communication best practices. Klarity will hold periodic webinars on best practices of managing text visits, too. 
        `,
    },
];
const FAQData2 = [
    {
        id: 5,
        pageId: 5,
        seq: 5,
        question: '5. How do patients start a Text Visit?',
        answer: `
        Patients fill out a structured intake form, describe their main concern, and pay for the visit. Their case is then added to the case pool.
        `,
    },
    {
        id: 6,
        pageId: 6,
        seq: 6,
        question: '6. How quickly must I respond after accepting a case?',
        answer: `
        You are expected to send a meaningful initial response to the patient within 1 hour of accepting a case. To ensure a positive patient experience, providers should only accept cases they can address promptly. Accepting multiple cases without responding in a timely manner is not permitted.
        `,
    },
    {
        id: 7,
        pageId: 7,
        seq: 7,
        question: '7. Can I choose which cases to accept?',
        answer: `
        Yes. You may browse the case pool and select cases that fit your expertise and availability.
        `,
    },
    {
        id: 8,
        pageId: 8,
        seq: 8,
        question: '8. What if I accept a case outside my expertise?',
        answer: `
        <div>
        You should only accept cases within your clinical comfort zone. If you accept by mistake, you can release the case back to the pool before responding within 10 minutes after accepting the case.
        </div>
        <div>
        If you decide to abandon the case without a visit notes (release the case back to the case pool) within 15 days, you’ll be charged a $25 penalty fee.
        <ul>
            <li>
                Not get any payment if you haven’t had meaningful interaction with the patient
            </li>
            <li>
                Potentially get partial payment if you have had substantial interaction with the patient and decided “unable to treat” due to medical reasons 
            </li>
        </ul>
        </div>
        <div>Klarity Ops will make the decisions for refund decision. </div>
        `,
    },
    {
        id: 9,
        pageId: 9,
        seq: 9,
        question: '9. How long should a case take to complete?',
        answer: `
        Klarity only open text visit to limited number of conditions that are common. Most cases can be completed in under 15 minutes. If you are waiting for the patient’s response, you may work on other cases in the meantime.
        `,
    },
    {
        id: 10,
        pageId: 10,
        seq: 10,
        question: '10. What if the patient doesn’t respond to my follow-up questions?',
        answer: `
        You can continue working on other cases. The case remains open until you submit a visit notes or until the 15-day window closes. 
        `,
    },
    {
        id: 11,
        pageId: 11,
        seq: 11,
        question: '11. What if I can’t provide care via text only?',
        answer: `
            <div>If the patient requires in-person or video visit or if their condition is outside the scope of asynchronous treatment, you should advise them to seek in-person evaluation. Document this recommendation in the portal.</div>
            <div>Please note that patient will make their own decisions to whether book with you or not for video visits. </div>
        `,
    },
    {
        id: 12,
        pageId: 12,
        seq: 12,
        question:
            '12. What happens to my payout for cases where I cannot make definite clinical decisions due to 1) patient not responding to my follow-up questions, 2) patients should see video or in-person visit?',
        answer: `
        <div>
        We understand that some patients may not respond after your initial assessment. In these situations, whether you are waiting for information to make a clinical decision or your best recommendation is for the patient to seek an in-person or video visit, you should still submit a visit notes. Clearly document your reasoning and the advice you provided in the plan. As long as your documentation shows appropriate clinical judgment, you will receive the at least partial payout for the case.
        </div>
        <div>
If you decide to abandon the case without a visit notes (release the case back to the case pool) within 15 days, you’ll 
        </div>
        <ul>
            <li>Not get any payment if you haven’t had meaningful interaction with the patient</li>
            <li>Potentially get partial payment if you have had substantial interaction with the patient and decided “unable to treat” due to medical reasons </li>
        </ul>
        Klarity Ops will make the decisions for refund decision. 
        `,
    },
];

const FAQData3 = [
    {
        id: 13,
        pageId: 13,
        seq: 13,
        question: '13. Can I prescribe medications?',
        answer: `
        Yes, you may prescribe medications when clinically appropriate. Prescriptions are sent directly to the patient’s preferred pharmacy input by patient during intake. You could use the native e-RX software in Klarity Provider Portal ($36/month) or you could use your own e-RX software. You could use Klarity’s e-RX (powered by ScriptSure) for patients from video visits or event patients outside of Klarity, too. 
        `,
    },
    {
        id: 14,
        pageId: 14,
        seq: 14,
        question: '14. Can I prescribe controlled substances?',
        answer: `
        Klarity does not offer Text Visits for conditions where controlled substances are commonly prescribed. If, during your assessment, you determine that a controlled substance is the most appropriate treatment, please use your clinical judgment and advise the patient accordingly.
        `,
    },
    {
        id: 15,
        pageId: 15,
        seq: 15,
        question: '15. How do I document the visit notes?',
        answer: `
        Use the Klarity Provider Portal to write your assessment and plan. This is shared directly with the patient once completed. Patient has access to their visit notes in the Klarity patient portal. 
        `,
    },
];

const FAQData4 = [
    {
        id: 16,
        pageId: 16,
        seq: 16,
        question: '16. How long can patients message me after I accept a case?',
        answer: `
        Patients can send follow-up questions for 15 days after you accept the case.
        `,
    },
    {
        id: 17,
        pageId: 17,
        seq: 17,
        question: '17. Am I paid separately for answering follow-ups questions?',
        answer: `
       No. Follow-up questions are bundled into the $20 case payment. It’s meant for providing consultation to patients who may have questions about their treatments, such as dosage, side-effects of their medication. 
        `,
    },
    {
        id: 18,
        pageId: 18,
        seq: 18,
        question: '18. What if a patient wants to continue after 15 days?',
        answer: `
        They must purchase a new Text Visit. They are free to submit the new case directly to you or other providers.
        `,
    },
    {
        id: 19,
        pageId: 19,
        seq: 19,
        question: '19. What if a patient is abusive or inappropriate?',
        answer: `
       You may end the message, keep the case open and email Klarity provider support team. Klarity’s support team will review and intervene as needed.
        `,
    },
];

const FAQData5 = [
    {
        id: 20,
        pageId: 20,
        seq: 20,
        question: '20. How much am I paid per case?',
        answer: `
        You are paid $20 per closed case. A case is considered closed after 15 days from the date you accept the case. 
        `,
    },
    {
        id: 21,
        pageId: 21,
        seq: 21,
        question: '21. When do I get paid?',
        answer: `
        Payments are processed monthly, within the first 5 business days. Only closed cases before the end of the previous month are counted. Open cases on the end of the previous month will go through the accounting process in the upcoming month.
        `,
    },
    {
        id: 22,
        pageId: 22,
        seq: 22,
        question: '22. How do I get paid?',
        answer: `
        Payment accounts
        <ul>
            <li>
                During limited testing phase, we’ll invite providers to bill.com. If an existing provider already has a bill.com associated with Klarity, we’ll use their existing bill.com accounts.
            </li>
            <li>
                After limited testing phase, we’ll enter a full roll-out phase. We may integrate with <a href="http://bill.com" target="_blank" rel="noopener noreferrer">bill.com</a> or other payment account tools to enable scaling payment processing. We’ll notify providers who participate in the text visit program then. 
            </li>
        </ul>
        `,
    },
    {
        id: 23,
        pageId: 23,
        seq: 23,
        question: '23. Are there additional incentives?',
        answer: `
        Yes. During peak demand seasons, Klarity may provide bonuses. Stay tuned!
        `,
    },
    {
        id: 24,
        pageId: 24,
        seq: 24,
        question: '24. What if a case is left open because I haven’t submitted a plan?',
        answer: `
        The case remains open until you provide a visit notes. Once closed, the case is considered payable. If it is not closed after 15 days of accepting the case, you’ll not be paid for this case and your future traffic from text visit will be limited. 
        `,
    },
    {
        id: 25,
        pageId: 25,
        seq: 25,
        question: 'What if a patient never responds at all?',
        answer: `
        <div>Refer to this question:</div>
        <div><b>12. What happens to my payout for cases where I cannot make definite clinical decisions due to 1) patient not responding to my follow-up questions, 2) patients should see video or in-person visit?</b></div>
        <div>We understand that some patients may not respond after your initial assessment. In these situations, whether you are waiting for information to make a clinical decision or your best recommendation is for the patient to seek an in-person or video visit, you should still submit a visit notes. Clearly document your reasoning and the advice you provided in the plan. As long as your documentation shows appropriate clinical judgment, you will receive the at least partial payout for the case.</div>
        <div>If you decide to abandon the case without a visit notes (release the case back to the case pool) within 15 days, you’ll </div>
        <ul>
            <li>Not get any payment if you haven’t had meaningful interaction with the patient</li>
            <li>Potentially get partial payment if you have had substantial interaction with the patient and decided “unable to treat” due to medical reasons  </li>
        </ul>
        Klarity Ops will make the decisions for refund decision. 
        `,
    },
    {
        id: 26,
        pageId: 26,
        seq: 26,
        question: '26. Will I receive a 1099 for taxes?',
        answer: `
        Yes. Klarity will provide tax documentation for your annual earnings.
        `,
    },
];

const FAQData6 = [
    {
        id: 27,
        pageId: 27,
        seq: 27,
        question: '27. Do I need my own malpractice insurance?',
        answer: `
        Yes. Providers are required to maintain active malpractice coverage. 
        `,
    },
    {
        id: 28,
        pageId: 28,
        seq: 28,
        question: '28. Is the Klarity portal HIPAA-compliant?',
        answer: `
        Yes. All communications and records are encrypted and stored securely in compliance with HIPAA regulations.
        `,
    },
    {
        id: 29,
        pageId: 29,
        seq: 29,
        question: '29. How long are patient records stored?',
        answer: `
        10 years. 
        `,
    },
    {
        id: 30,
        pageId: 30,
        seq: 30,
        question: '30. What support is available if I encounter technical or clinical issues?',
        answer: `
        You can contact Klarity’s provider support team through the portal for help or escalation guidance. 
        `,
    },
];

const FAQ = () => {
    return (
        <div className={s.wrap}>
            <h2 className={s.title}>Frequently asked questions</h2>
            <h3>Getting Started</h3>
            <FrequencyQuestionSecion data={FAQData1} largerFontsize />
            <h3>Workflow & Case Management</h3>
            <FrequencyQuestionSecion data={FAQData2} largerFontsize />
            <h3>Prescriptions & Treatment</h3>
            <FrequencyQuestionSecion data={FAQData3} largerFontsize />
            <h3>Follow-ups & Patient Communication</h3>
            <FrequencyQuestionSecion data={FAQData4} largerFontsize />
            <h3>Payments & Incentives</h3>
            <FrequencyQuestionSecion data={FAQData5} largerFontsize />
            <h3>Compliance & Liability</h3>
            <FrequencyQuestionSecion data={FAQData6} largerFontsize />
        </div>
    );
};

export default FAQ;
